import { render } from "./CameraZones.vue?vue&type=template&id=0fe61e0b&ts=true"
import script from "./CameraZones.vue?vue&type=script&lang=ts"
export * from "./CameraZones.vue?vue&type=script&lang=ts"

import "./CameraZones.vue?vue&type=style&index=0&id=0fe61e0b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__